module.exports = __webpack_public_path__ + "static/media/events.5512b02e.png";